export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^[0-9]{5}(-[0-9]{4})?$/));
    }
}
